import DefaultContentTemplateEmbedded from '@/components/DefaultContentTemplate/Embedded';
import { useChapterStore } from '../../../shared/store/useChapterStore';
import { GENERATED } from '@edwin-group/cj-graphql';

export const ClassVideo = () => {
  const chapter = useChapterStore((state) => state.chapter);
  const chapterPage = useChapterStore((state) => state.chapterPage);

  if (!chapter || !chapterPage || !chapter?.classVideoUrl) return null;

  return (
    <div className="mb-6">
      <div className="aspect-video w-full">
        <DefaultContentTemplateEmbedded
          className="mindful-video !my-0"
          fitContent
          // @ts-expect-error DEPRECATED_STRAPI_ATTRIBUTES
          component={{
            id: 'DefaultContentTemplateEmbedded',
            link: chapter.classVideoUrl,
            provider: GENERATED.Enum_Componentcommonembedded_Provider.Vimeo,
          }}
        />
      </div>
    </div>
  );
};
